import { useEffect, useState } from "react";
import { getToken } from "../../libs/auth";
import { CognitoUser } from "../../types";
import { HooksLogger } from "../hooks-logger";

const logger = new HooksLogger("useJWT.ts");

export const useJWT = (user: CognitoUser | null) => {
  const [jwt, setJWT] = useState(() => "");
  useEffect(() => {
    const query = async () => {
      logger.request("Getting token");
      try {
        const token = await getToken();
        setJWT(token);
        logger.success();
      } catch (e: any) {
        const error = e.message ? e.message : e;
        logger.error(error);
      }
    };

    if (user) query();
  }, [user]);

  return jwt;
};
